
// The Tender shortlisting edit functions
var TECL_UserTenderShortlistEdit = {

  // Initialise the Tenders edit page
  Initialise: function() {

    // Change the sorting type
    $("#ddlTenderSummariesSortOrder").change(function() {
      TECL_UserTenderGeneric.ChangeSummarySortOrder();
    });

    $("#continueDialogContinueBtn").click(function() {
      TECL_UserTenderShortlistEdit.ContinueSelected();
      $("#continueDialog").modal("hide");
    });

    TECL_UserTenderShortlistEdit.UpdateContinueButtons();

    var jumpPoint = $("#JumpPoint").val();
    if (jumpPoint && jumpPoint == 1) {
      $("html,body").animate({ scrollTop: $("#scrollToSupplierMarker").offset().top }, "slow");
    } else {
      window.scrollTo(0, 0);
    }
  },
  
  // Update the state of the continue buttons
  UpdateContinueButtons: function() {
    var isValid = TECL_UserTenderShortlistEdit.ValidatePage();
    $("[name=continueBtn]").prop('disabled', !isValid);
  },

  // Display the continue dialog
  DisplayContinueDialog: function() {
    $("#continueDialog").modal("show");
  },

  // Shortlisting continue button selected 
  ContinueSelected: function() {
    var tenderId = $("#TenderId").val();

    if (tenderId) {

      if (TECL_Master.AddLock("ContinueSelectedOnShortlisting")) {

        if (TECL_UserTenderShortlistEdit.ValidatePage()) {
          $.ajax({
            url: baseSiteUrl + "TenderUserSurface/ContinueSelectedOnShortlisting",
            dataType: "json",
            type: "POST",
            data: {
              tenderId: tenderId
            },
            error: function(exc) {
              TECL_Master.ClearLock("ContinueSelectedOnShortlisting");
            },
            success: function(saveData) {
              TECL_Master.ClearLock("ContinueSelectedOnShortlisting");
              if (saveData && saveData.Saved === true && saveData.NextStageUrl) {
                window.location = saveData.NextStageUrl;
              } else {
                TECL_Master.ShowErrorDialog("Failed to save stage change.");
              }
            }
          });
        } else {
          TECL_Master.ClearLock("ContinueSelectedOnShortlisting");
          $("#validationErrorDialog").modal("show");
        }
      }
    }
  },

  // Validate the current page
  ValidatePage: function() {
    var anySuppliersShortlistedStatus = false;
    var anySuppliersWithNonSelectStatus = false;

    $("#tenderSummariesTable").find("[name=supplierStatusButtons]").each(function() {
      if (!$(this).find("[name=RejectShortListingButtons]").hasClass("hidden")) {
        anySuppliersWithNonSelectStatus = true;
      } else if (!$(this).find("[name=UndoShortListingLink]").hasClass("hidden")) {
        anySuppliersShortlistedStatus = true;
      }
    });

    var isValid = anySuppliersShortlistedStatus && !anySuppliersWithNonSelectStatus;
    return isValid;
  },

  // Change the supplier status in the tender to the supplied value
  ChangeSupplierTenderStatus: function(supplierTenderId, rowId, newStatus) {

    if (supplierTenderId) {
      if (TECL_Master.AddLock("ChangeSupplierTenderStatus")) {
        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/ChangeTenderSupplierStatus",
          dataType: "json",
          type: "POST",
          data: {
            supplierTenderId: supplierTenderId,
            newStatus: newStatus
          },
          error: function(exc) {
            TECL_Master.ClearLock("ChangeSupplierTenderStatus");
          },
          success: function(result) {
            TECL_Master.ClearLock("ChangeSupplierTenderStatus");
            if (result && result === true) {
              if (newStatus === "reject") {
                $("#" + rowId).find("[name=RejectShortListingButtons]").addClass("hidden");
                $("#" + rowId).find("[name=UndoRejectLink]").removeClass("hidden");
                $("#" + rowId).find("[name=UndoShortListingLink]").addClass("hidden");

              } else if (newStatus === "shortlist") {
                $("#" + rowId).find("[name=RejectShortListingButtons]").addClass("hidden");
                $("#" + rowId).find("[name=UndoRejectLink]").addClass("hidden");
                $("#" + rowId).find("[name=UndoShortListingLink]").removeClass("hidden");

              } else if (newStatus === "undoreject" || newStatus === "undoshortlist") {
                $("#" + rowId).find("[name=RejectShortListingButtons]").removeClass("hidden");
                $("#" + rowId).find("[name=UndoRejectLink]").addClass("hidden");
                $("#" + rowId).find("[name=UndoShortListingLink]").addClass("hidden");
              }

              TECL_UserTenderShortlistEdit.UpdateContinueButtons();
            } else {
              TECL_Master.ShowErrorDialog("Failed to change supplier status.");
            }
          }
        });
      }
    }
  }

};
